<template>
  <div class="button-menu-wrapper" >
    <span class="new-item stop-event" v-if="isNew">new</span>
    <div class="button-menu stop-event">
        <span class="button-menu-icon base-sprite" :class="iconClass" v-if="iconClass"></span>
        <span class='button-menu-label'  v-if="label">{{label}}</span>
    </div>
  </div>
</template>
<script>
//////////////////////////////////////
// IMPORT
/////////////////////////////////////

//////////////////////////////////////
// CLASS
/////////////////////////////////////
export default {
  name: 'ButtonMenu',
  components: {
  },
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  data () {
    return {}
  },
  props: {
    iconClass:{
      type:String,
      default:''
    },
    label:{
      type:String,
      default:''
    },
    isNew:{
      type:Boolean,
      default:false
    }
  },
  computed: {},
  methods: {},
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/buttons/ButtonMenu.vue